/* src/app/modules_v2/income/grant/components/grant-list/grant-list.components.css */
.quick-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}
.quick-filter .qf-search,
.quick-filter .qf-field {
  height: 36px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  background: #fff;
  font-size: 13px;
  line-height: 1;
  box-sizing: border-box;
  margin: 0;
  align-self: center;
  display: flex;
  align-items: center;
  vertical-align: middle;
}
.quick-filter .qf-search {
  padding: 0 10px;
  outline: none;
  width: 220px;
}
.quick-filter .qf-search:focus {
  border-color: var(--cf-brand-dark);
}
.quick-filter .qf-field {
  width: 200px;
}
.quick-filter ::ng-deep .qf-field .mat-form-field-outline,
.quick-filter ::ng-deep .qf-field .mat-form-field-underline,
.quick-filter ::ng-deep .qf-field .mat-form-field-label-wrapper,
.quick-filter ::ng-deep .qf-field .mat-form-field-subscript-wrapper {
  display: none !important;
}
.quick-filter ::ng-deep .qf-field .mat-form-field-wrapper {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.quick-filter ::ng-deep .qf-field .mat-form-field-flex {
  padding: 0 10px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  background: transparent;
  width: 100%;
  height: 100%;
}
.quick-filter ::ng-deep .qf-field .mat-form-field-infix {
  padding: 0 !important;
  border-top: 0 !important;
  width: auto;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
}
.quick-filter ::ng-deep .qf-field .mat-select-arrow-wrapper {
  transform: none;
}
.total-card {
  background: #fff;
  border-radius: 12px;
  padding: 8px 20px;
  margin: 0;
  text-align: center;
  min-width: 230px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}
.total-card .label {
  font-size: 13px;
  color: #666;
  margin: 0;
}
.nav-pills .nav-link {
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
}
.nav-link.active {
  background-color: var(--cf-brand-dark);
  color: white;
  transition: all 0.2s ease-in-out;
  border-radius: 0.25rem;
}
.nav-link:not(.disabled):hover {
  background-color: var(--cf-brand-dark);
  color: white;
  transform: scale(1.02);
  cursor: pointer;
}
/*# sourceMappingURL=grant-list.components.css.map */
